var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { usePopup } from "@/hooks/layout";
import { Slot } from "@/utils/types/layout";
import { useGetFiltersQuery } from "@/store/api";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import copy from "fast-copy";
import { useAppDispatch, useAppSelector } from "@/hooks/store";
import { setFiltersSelected } from "@/store/filterSlice";
import { useTranslation } from "react-i18next";
import { SelectorMultiple } from "@/components/dev/selector/multiple";
import { logger } from "@/utils/loggerService";
import { DashletContext } from "../module/home/dashboard";
export default function WidgetSelector(_a) {
    var _this = this;
    var _b, _c, _d;
    var widget = _a.widget, onChange = _a.onChange;
    // This is for dashlet
    var _e = useContext(DashletContext), settings = _e.settings, editedSettings = _e.editedSettings;
    var _f = useTranslation(["common", "Users", "Administration"]), t = _f.t, i18n = _f.i18n;
    var popup = usePopup();
    var _g = useState(), record = _g[0], setRecord = _g[1];
    var module = useParams().module;
    var isInWidget = (_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.isInWidget;
    var isInDashlet = (_c = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _c === void 0 ? void 0 : _c.isInDashlet;
    var moduleFromWidget = widget === null || widget === void 0 ? void 0 : widget.payload.module;
    var selectedFilterWidget = widget === null || widget === void 0 ? void 0 : widget.payload.selectedFilters;
    var moduleName = isInWidget
        ? moduleFromWidget
        : module
            ? module
            : "Accounts";
    var filters_selected_state = useAppSelector(function (state) { return state.filter.selector_filters; });
    var defaultSelectedFilterWidget = selectedFilterWidget && selectedFilterWidget.map(function (obj) { return obj.id; });
    var _h = useState(isInWidget ? defaultSelectedFilterWidget : []), selectedFilters = _h[0], setSelectedFilters = _h[1];
    var dispatch = useAppDispatch();
    useEffect(function () {
        !isInWidget && dispatch(setFiltersSelected(selectedFilters));
    }, []);
    useEffect(function () {
        var _a;
        var dataSelectedViewFromWdgt = (_a = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _a === void 0 ? void 0 : _a.selectedFilters;
        if (!dataSelectedViewFromWdgt) {
            !isInWidget &&
                setSelectedFilters((filters_selected_state &&
                    filters_selected_state.map(function (item) { return item === null || item === void 0 ? void 0 : item.id; })) ||
                    []);
        }
    }, [filters_selected_state]);
    useEffect(function () {
        var _a;
        var dataSelectedViewFromWdgt = (_a = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _a === void 0 ? void 0 : _a.selectedFilters;
        if (dataSelectedViewFromWdgt) {
            !isInWidget &&
                setSelectedFilters(dataSelectedViewFromWdgt.map(function (item) { return item.id; }) || []);
        }
    }, [(_d = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _d === void 0 ? void 0 : _d.selectedFilters]);
    var _j = useGetFiltersQuery(moduleName || "Accounts"), filterList = _j.data, isLoading = _j.isLoading, isError = _j.isError, isFetching = _j.isFetching;
    useEffect(function () {
        var data = filterList === null || filterList === void 0 ? void 0 : filterList.data;
        setRecord((data === null || data === void 0 ? void 0 : data.filters[moduleName]) || []);
    }, [filterList]);
    var onSelectHandler = function (value) {
        setSelectedFilters(value);
        var list_filters_value_selected = record === null || record === void 0 ? void 0 : record.filter(function (element, index) {
            for (var i = 0; i < value.length; i++) {
                if (element.id == value[i]) {
                    return element.filters;
                }
            }
        });
        !isInWidget && dispatch(setFiltersSelected(list_filters_value_selected));
        // For dashlet
        if (isInDashlet) {
            editedSettings(__assign(__assign({}, settings), { dashlet: __assign(__assign({}, settings.dashlet), { filters: list_filters_value_selected }) }));
        }
        onChange &&
            onChange(widget, __assign(__assign({}, widget.payload), { selectedFilters: list_filters_value_selected }));
    };
    var removeItem = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var copySelectedFilters, list_filters_value_selected;
        return __generator(this, function (_a) {
            copySelectedFilters = copy(selectedFilters);
            copySelectedFilters.splice(id, 1);
            setSelectedFilters(copySelectedFilters);
            list_filters_value_selected = record === null || record === void 0 ? void 0 : record.filter(function (element, index) {
                for (var i = 0; i < copySelectedFilters.length; i++) {
                    if (element.id == copySelectedFilters[i]) {
                        return element.filters;
                    }
                }
            });
            logger.debug("list_filters_value_selected: ", list_filters_value_selected, copySelectedFilters);
            !isInWidget && dispatch(setFiltersSelected(list_filters_value_selected));
            // For dashlet
            if (isInDashlet) {
                editedSettings(__assign(__assign({}, settings), { dashlet: __assign(__assign({}, settings.dashlet), { filters: list_filters_value_selected }) }));
            }
            onChange &&
                onChange(widget, __assign(__assign({}, widget.payload), { selectedFilters: list_filters_value_selected }));
            return [2 /*return*/];
        });
    }); };
    var addedValue = (_jsxs("div", __assign({ className: "justify-center p-3 cursor-pointer items-center border-t-[1px]" }, { children: [_jsx("p", __assign({ className: "text-[var(--color-brand-blue-800)] hover:text-[rgb(var(--color-gray-500))]", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                    var result;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, popup.showPopup({
                                    type: "widget/managerFilter",
                                    slot: Slot.DRAWER_SOUTH,
                                    payload: { new: true, module: (_a = widget.payload) === null || _a === void 0 ? void 0 : _a.module },
                                })];
                            case 1:
                                result = _b.sent();
                                return [2 /*return*/];
                        }
                    });
                }); } }, { children: t("app.LBL_NEW_FILTER") })), _jsx("p", __assign({ className: "text-[rgb(var(--color-blue-800))] hover:text-[rgb(var(--color-gray-500))] pb-1", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                    var result;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, popup.showPopup({
                                    type: "widget/managerFilter",
                                    slot: Slot.DRAWER_SOUTH,
                                    payload: { module: (_a = widget.payload) === null || _a === void 0 ? void 0 : _a.module },
                                })];
                            case 1:
                                result = _b.sent();
                                return [2 /*return*/];
                        }
                    });
                }); } }, { children: t("app.LBL_MANAGE_FILTERS") }))] })));
    return (_jsx("div", __assign({ className: "p-0 bg-transparent" }, { children: _jsx(SelectorMultiple, { placeholder: String(t("app.LBL_ADVANCED_FILTER")), record: record, selectedFilters: selectedFilters || [], addedValue: !isInWidget ? addedValue : "", onSelectChange: function (event, value) {
                onSelectHandler(value);
            }, onDeleteSelect: function (index) {
                removeItem(index);
            } }) })));
}
widgetsDictionary.register("widget/selectorFilter", {
    name: "Widget selector filter",
    display: WidgetSelector,
});
